import { render, staticRenderFns } from "./selectShopGoods.vue?vue&type=template&id=4e5f40a8&scoped=true"
import script from "./selectShopGoods.vue?vue&type=script&lang=js"
export * from "./selectShopGoods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5f40a8",
  null
  
)

export default component.exports